import React, { useEffect, useState } from 'react';
import { Container, Box, Button, Typography, Grid } from '@mui/material';
import { Link } from 'react-router-dom';

const HomePage = ({ authenticatedUser, loginComponent }) => {

  const [isPWAInstalled, setIsPWAInstalled] = useState(false);

  useEffect(() => {
    const checkPWAInstallation = () => {
      const isLocalhost = window.location.hostname === 'localhost';
      if (isLocalhost) {
        return true; 
      }
      const isStandalone = window.navigator.standalone;
      const isInstalled = window.matchMedia('(display-mode: standalone)').matches;
      return isStandalone || isInstalled;
    };
    setIsPWAInstalled(checkPWAInstallation());
  }, []);

  return (
    <>
      <Box
        sx={{
          backgroundColor: 'black',
          color: 'white',
          textAlign: 'center',
          position: 'relative',
          paddingBottom: 4,
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 0,
            width: 0,
            height: 0,
            borderLeft: '100vw solid transparent',
            borderTop: '35px solid black',
            transform: 'translateY(100%)',
          },
        }}
      >
        <Box
          component="img"
          src="/icon-512x512.png"
          alt="Logo"
          sx={{
            width: 256,
            height: 256,
            position: 'relative',
            top: 20,
          }}
        />
        <Typography variant="h5" sx={{ margin: 2 }}>
          ¿No sabes qué ver hoy?
        </Typography>
      </Box>

      <Container maxWidth="sm" sx={{ marginTop: '50px' }}>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          {!isPWAInstalled ? (
            <>
              <Grid item xs={12} sx={{ textAlign: 'center', padding: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Olvidate de las búsquedas interminables.
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Instalá la app para empezar a explorar las sugerencias de quienes más te conocen y no quedarte afuera de nada.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                <Button
                  component={Link}
                  to="/installation-guide"
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  style={{ borderRadius: '20px', padding: '10px 20px', fontSize: '1rem' }}
                >
                  Instalar Flickers
                </Button>
              </Grid>
            </>
          ) : (
            authenticatedUser ? (
              <>
                <Grid item xs={12}>
                  <Button
                    component={Link}
                    to="/recommendations"
                    variant="contained"
                    color="primary"
                    fullWidth
                    style={{ borderRadius: '20px', padding: '10px 20px', fontSize: '1rem' }}
                  >
                    Ver recomendaciones
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Button
                    component={Link}
                    to="/addreview"
                    variant="contained"
                    color="error"
                    fullWidth
                    style={{ borderRadius: '20px', padding: '10px 20px', fontSize: '1rem' }}
                  >
                    Recomendar
                  </Button>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} sx={{ textAlign: 'center', padding: 2 }}>
                  <Typography variant="h6" gutterBottom>
                    Olvidate de las búsquedas interminables.
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Explorá las sugerencias de quienes más te conocen y no te quedes afuera de nada.
                  </Typography>
                </Grid>
                {loginComponent}
              </>
            )
          )}
        </Grid>
      </Container>
    </>
  );
};

export default HomePage;
